/**
 * Topbar Mobile Slider
 * Creates an auto-rotating slider for topbar items on mobile devices
 */
class TopbarMobileSlider {
  constructor() {
    this.slider = document.querySelector('.topbar__mobile-slider');
    this.wrapper = document.querySelector('.topbar__mobile-slider-wrapper');
    this.slides = [];
    this.currentIndex = 0;
    this.interval = null;
    this.intervalDuration = 4000; // 4 seconds per slide
    
    if (!this.slider || !this.wrapper) return;
    
    this.init();
  }
  
  init() {
    // Get all slides
    this.slides = Array.from(this.wrapper.querySelectorAll('.topbar__mobile-slide'));
    
    // Filter out empty slides
    this.slides = this.slides.filter(slide => {
      const content = slide.textContent.trim();
      return content.length > 0;
    });
    
    if (this.slides.length <= 1) {
      // If only one or no slides, just show it without slider functionality
      if (this.slides.length === 1) {
        this.slides[0].classList.add('active');
      }
      return;
    }
    
    // Sort slides by priority (data-priority attribute)
    this.slides.sort((a, b) => {
      const priorityA = parseInt(a.dataset.priority) || 999;
      const priorityB = parseInt(b.dataset.priority) || 999;
      return priorityA - priorityB;
    });
    
    // Reorder slides in DOM based on sorted order
    this.slides.forEach((slide, index) => {
      this.wrapper.appendChild(slide);
      slide.style.order = index;
    });
    
    // Show first slide
    this.showSlide(0);
    
    // Start auto-rotation
    this.startAutoRotate();
    
    // Pause on hover (if touch device, this won't trigger, but that's fine)
    this.slider.addEventListener('mouseenter', () => this.stopAutoRotate());
    this.slider.addEventListener('mouseleave', () => this.startAutoRotate());
    
    // Pause on touch (mobile)
    let touchStartTime = 0;
    this.slider.addEventListener('touchstart', () => {
      touchStartTime = Date.now();
      this.stopAutoRotate();
    });
    
    this.slider.addEventListener('touchend', () => {
      // Resume after a short delay
      setTimeout(() => {
        this.startAutoRotate();
      }, 2000);
    });
  }
  
  showSlide(index) {
    // Remove active class from all slides
    this.slides.forEach(slide => {
      slide.classList.remove('active');
      slide.style.opacity = '0';
      slide.style.transform = 'translateX(20px)';
    });
    
    // Add active class to current slide
    if (this.slides[index]) {
      this.slides[index].classList.add('active');
      // Trigger reflow for animation
      void this.slides[index].offsetWidth;
      this.slides[index].style.opacity = '1';
      this.slides[index].style.transform = 'translateX(0)';
    }
    
    this.currentIndex = index;
  }
  
  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }
  
  startAutoRotate() {
    this.stopAutoRotate(); // Clear any existing interval
    this.interval = setInterval(() => {
      this.nextSlide();
    }, this.intervalDuration);
  }
  
  stopAutoRotate() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

// Helper function to check if we're on mobile
function isMobile() {
  return window.innerWidth < 1024;
}

// Initialize when DOM is ready - only on mobile
function initMobileSlider() {
  if (isMobile()) {
    new TopbarMobileSlider();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileSlider);
} else {
  initMobileSlider();
}

// Re-initialize on resize if switching to mobile
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const slider = document.querySelector('.topbar__mobile-slider');
    if (slider && isMobile() && !slider.dataset.initialized) {
      slider.dataset.initialized = 'true';
      new TopbarMobileSlider();
    }
  }, 250);
});

